<template>
  <div class="personal-info">
    <div class="title">开票信息</div>
    <div class="form">
      <div class="form-line">
        <div class="form-left"><span>*</span>类型：</div>
        <div class="form-right">
          <el-radio-group v-model="invoiceInfo.type">
            <el-radio label="person">企业</el-radio>
            <el-radio label="company">高校&研究所</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="form-line">
        <div class="form-left"><span>*</span>机构名称：</div>
        <div class="form-right">
          <el-input v-model="invoiceInfo.name" placeholder="请输入机构名称（抬头）"></el-input>
        </div>
      </div>
      <div class="form-line">
        <div class="form-left"><span>*</span>单位税号：</div>
        <div class="form-right">
          <el-input v-model="invoiceInfo.tax_no" placeholder="请输入单位税号"></el-input>
        </div>
      </div>
      <div class="form-line">
        <div class="form-left">法人：</div>
        <div class="form-right">
          <el-input v-model="invoiceInfo.legal_person" placeholder="请输入法人"></el-input>
        </div>
      </div>
      <div class="form-line">
        <div class="form-left">开户银行：</div>
        <div class="form-right">
          <el-input v-model="invoiceInfo.bank_name" placeholder="请输入开户银行"></el-input>
        </div>
      </div>
      <div class="form-line">
        <div class="form-left">银行账号：</div>
        <div class="form-right">
          <el-input v-model="invoiceInfo.bank_no" placeholder="请输入银行账号"></el-input>
        </div>
      </div>
      <div class="form-line">
        <div class="form-left">企业地址：</div>
        <div class="form-right">
          <el-input v-model="invoiceInfo.address" placeholder="请输入企业地址"></el-input>
        </div>
      </div>
      <div class="form-line">
        <div class="form-left">企业电话：</div>
        <div class="form-right">
          <el-input v-model="invoiceInfo.mobile" placeholder="请输入企业电话"></el-input>
        </div>
      </div>
    </div>
    <div class="bottom-button">
      <div class="red-button" @click="saveInvoiceInfo">保存资料</div>
      <div class="red-button" @click="resetInvoiceInfo">重置信息</div>
    </div>
  </div>
</template>
<script>
  import userApi from '@/api/user'
  export default {
    data() {
      return {
        invoiceInfo    : {},
        invoiceInfoCopy: {}
      };
    },
    created() {
      this.$emit("getCompontsIndex", 4);
      this.getInvoiceInfo();
    },
    methods: {
      // 获取用户开票信息
      async getInvoiceInfo() {
        let {data} = await userApi.invoice.list()
        if(data.length > 0) {
          this.invoiceInfo = {...data[0]}
          this.invoiceInfoCopy = {...data[0]}
        }
      },
      // 保存资料
      async saveInvoiceInfo() {
        if(this.invoiceInfo.id) {
          await userApi.invoice.update(this.invoiceInfo.id, this.invoiceInfo)
        } else {
          await userApi.invoice.create(this.invoiceInfo)
        }

        this.$message({
          message: '更新成功！',
          type: "success"
        });
        this.getInvoiceInfo();
      },
      // 重置信息
      resetInvoiceInfo() {
        this.invoiceInfo = {...this.invoiceInfoCopy};
      }
    }
  };
</script>
<style lang="less" scoped>
  @import url("./index.less");
</style>
